
import "react-toastify/dist/ReactToastify.css";
import "./comman.scss";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import DashboardCardContent from "./pages/dashboard/dashboard_data/DashboardCardContent";
import { useSelector } from "react-redux";
import NoDashboardPermission from "./pages/dashboard/no_dashboard_permission/NoDashboardPermission";
import ToastComponent from "./components/customTable/ToastComponent";
import NewDashboardCardContent from "./pages/dashboard/dashboard_data/NewDashboardCardContent";

const App = () => {
  
  const roleResponse = useSelector((state) => state.login.login.role);

  return (
    <>
      {/* */}
      {roleResponse?.Dashboard?.read === 1 ? (<>

        <NewDashboardCardContent />
        {/* <DashboardCardContent /> */}
      </>
      ) : (
        <NoDashboardPermission />
      )}
    </>
  );
};

export default App;
